import * as ActionTypes from './ActionTypes';

export const clearSeenFields = () => ({
    type: ActionTypes.CLEAR_SEEN_FIELDS,
});

export const addSeenFields = ({ seenFields } = {}) => ({
    type: ActionTypes.ADD_SEEN_FIELDS,
    payload: { seenFields: seenFields || [] },
});
